import { AppState } from '@/store/app.state';

export const selectTradeCaptureStatus = ({ tradeCapture }: AppState) => tradeCapture.status
